import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-253e6397"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "title" }
const _hoisted_2 = { class: "title-left" }
const _hoisted_3 = { class: "title-name" }
const _hoisted_4 = { class: "title-time" }
const _hoisted_5 = { class: "air-card" }
const _hoisted_6 = { class: "left" }
const _hoisted_7 = { class: "expression" }
const _hoisted_8 = { class: "aqi-value" }
const _hoisted_9 = { class: "factor-value" }
const _hoisted_10 = ["title"]
const _hoisted_11 = { class: "factor-txt" }
const _hoisted_12 = { class: "card-lower" }
const _hoisted_13 = { class: "title" }
const _hoisted_14 = { class: "unit" }
const _hoisted_15 = { class: "weather" }
const _hoisted_16 = { class: "chart" }
const _hoisted_17 = { class: "chart-title" }
const _hoisted_18 = { id: "chart-container" }
const _hoisted_19 = { class: "no-data" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Progress = _resolveComponent("Progress")!

  return (_openBlock(), _createElementBlock("div", {
    id: "env-popup",
    ref: "popupRef",
    class: _normalizeClass(_ctx.props.theme)
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.dataPop.name), 1),
        _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.titleTime), 1)
      ]),
      (_ctx.popupData.infoWinType ==='country')
        ? (_openBlock(), _createElementBlock("span", {
            key: 0,
            class: _normalizeClass(['exceed-btn',_ctx.exceedActive?'active':'' ]),
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.exceedClick && _ctx.exceedClick(...args)))
          }, "一键溯源", 2))
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        class: "iconfont icon-close close",
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.changeRankingVisable && _ctx.changeRankingVisable(...args)))
      })
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", {
        class: "card-upper",
        style: _normalizeStyle({'background-color': _ctx.thresholdInfo.color})
      }, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("span", {
              class: _normalizeClass(['iconfont', `icon-emo-${_ctx.thresholdInfo.emo}`]),
              style: _normalizeStyle(_ctx.aqiFontColor)
            }, null, 6)
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", {
              class: "value-txt",
              style: _normalizeStyle(_ctx.aqiFontColor)
            }, _toDisplayString(_ctx.getAqiValue), 5),
            _createElementVNode("div", {
              class: "name-txt",
              style: _normalizeStyle(_ctx.aqiFontColor)
            }, " AQI指数 ", 4)
          ])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", {
            class: "prompt-language",
            title: _ctx.suggestionText,
            style: _normalizeStyle(_ctx.aqiFontColor)
          }, _toDisplayString(_ctx.suggestionText), 13, _hoisted_10),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", {
              class: "name-txt",
              style: _normalizeStyle(_ctx.firstPollutionColor)
            }, " 首要污染物:" + _toDisplayString(_ctx.firstPollutionText), 5)
          ])
        ])
      ], 4),
      _createElementVNode("div", _hoisted_12, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pollute, (item) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "item",
            key: item.key
          }, [
            _createElementVNode("span", _hoisted_13, _toDisplayString(item.name), 1),
            _createVNode(_component_Progress, {
              percent: _ctx.getPercent(item),
              showInfo: false,
              strokeColor: _ctx.factorColor(item, ''),
              trailColor: _ctx.factorColor(item, '11'),
              size: "small"
            }, null, 8, ["percent", "strokeColor", "trailColor"]),
            _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.polluteInfo(item, _ctx.dataPop)), 1)
          ]))
        }), 128))
      ])
    ]),
    _createElementVNode("div", _hoisted_15, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.weather, (item) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "item",
          key: item.key
        }, _toDisplayString(_ctx.weatherInfo(item, _ctx.weatherVo)), 1))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_16, [
      _createElementVNode("div", _hoisted_17, "历史三天" + _toDisplayString(_ctx.factorKey[_ctx.indexName]) + "变化图", 1),
      _withDirectives(_createElementVNode("div", _hoisted_18, null, 512), [
        [_vShow, _ctx.historyData.length]
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_19, null, 512), [
        [_vShow, !_ctx.historyData.length]
      ])
    ])
  ], 2))
}